export default {
    attribute: {
        urls: {
            '0':'',
            '1':'',
            '2':'',
            '3':''
        },
        cptTableData: [{ "name": "指标", "value": "", "namekey": "value" }]
    },
    cptDataForm:{dataText:'{"value":"0"}',dataSource: 1, pollTime: 0,apiUrl:'/text'},
}
